import * as CryptoJS from 'crypto-js'

import { environment as env } from '@env'

export function decrypter(encryptedBase64: string): string {
	const key = CryptoJS.enc.Utf8.parse(env.secretKey)
	const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	})

	return decrypted.toString(CryptoJS.enc.Utf8)
}
